// import AlertDialog from '@/components/AlertDialog'

export default {
    methods: {
        alert(text, title = '알림') {
            return this.$dialog.confirm({
                title,
                text : `${text}`,
                actions: {
                    true: {
                        text: '확인',
                        color: '#3f6fff',
                        attrs: {
                            width: '100%'
                        },
                        block: true,
                        width: '100%',
                        flat: false,
                        elevation: 0,
                        dark: true
                    },
                    spacer: false
                }
            })
        },
        asyncAlert (text) {
            return this.$dialog.confirm({
                title: '알림',
                text,
                actions: {
                    true: {
                        text: '확인',
                        color: '#3f6fff',
                        attrs: {
                            width: '100%'
                        },
                        block: true,
                        width: '100%',
                        flat: false
                    },
                    spacer: false
                }
            })
        }
    }
}
